/**
 * Observer cache
 * @type {IntersectionObserver}
 */
let observer

/**
 * Set data-src value to src
 * @param {HTMLElement} img <img> element
 */
function loadImg (img) {
  img.src = img.dataset.src

  img.onload = function () {
    img.style.opacity = '1'
  }
}

/**
 * Set data-src and data-srcset values to src and srcset
 * @param {HTMLElement} picture <picture> element
 */
function loadPicture (picture) {
  const img = picture.querySelector('img')
  const sources = picture.querySelectorAll('source')

  img.src = img.dataset.src

  for (let i = 0; i < sources.length; i++) {
    sources[i].srcset = sources[i].dataset.srcset
  }

  img.onload = function () {
    picture.style.opacity = '1'
  }
}

/**
 * Detect container type
 * @param {HTMLElement} container <img> or <picture>
 */
function loadContainer (container) {
  switch (container.nodeName) {
    case 'IMG':
      loadImg(container)
      break

    case 'PICTURE':
      loadPicture(container)
      break
  }
}

/**
 * Handle call from IntersectionObserver
 * @param {IntersectionObserverEntry} entry Element entry
 */
function handleEntry (entry) {
  if (entry.isIntersecting) {
    loadContainer(entry.target)
    observer.unobserve(entry.target)
  }
}

if (global.IntersectionObserver) {
  observer = new IntersectionObserver(entries => {
    entries.forEach(handleEntry)
  })
}

/**
 * Lazy load images with IntersectionObserver
 * with a fallback for older browsers
 * @param {HTMLElement} element <img> or <picture>
 */
function lazyLoad (element) {
  element.style.opacity = '0'
  element.style.transition = 'opacity 400ms'

  if (observer) {
    observer.observe(element)
  } else {
    loadContainer(element)
  }
}

export default lazyLoad
